import { Fragment } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { styled } from '@mui/material/styles';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Typography } from '@components/Typography';
import { useTranslation } from '@hooks';
import AutoCloseInput from './AutoCloseInput';

const StyledRadioGroup = styled(RadioGroup)({
    flexDirection: 'row',
    alignItems: 'center',
    '& .MuiFormControlLabel-root': {
        marginRight: 0,
        marginLeft: '-3px !important',
    },
});

export const AutoCloseEnum = {
    DoNothing: '0',
    Close: '1',
    Unassign: '2',
};

const AutoClose = ({ isView }) => {
    const { t } = useTranslation();
    const { control, setValue, watch, clearErrors } = useFormContext();

    const autoClose = watch('autoClose');

    return (
        <div>
            <Typography variant="subtitle1" sx={{ color: 'rgba(0, 0, 0, 0.87)' }}>
                {t('Agents.autoCloseTitle')}
            </Typography>
            <Typography variant="caption" sx={{ color: 'rgba(0, 0, 0, 0.6)', display: 'block', marginTop: '4px' }}>
                {t('Agents.autoCloseDescription')}
            </Typography>
            <Controller
                control={control}
                name="autoClose"
                render={({ field }) => (
                    <div>
                        {[
                            { id: AutoCloseEnum.Close, name: t('Agents.closeConversation') },
                            { id: AutoCloseEnum.Unassign, name: t('Agents.changeToUnassigned') },
                            { id: AutoCloseEnum.DoNothing, name: t('Agents.doNothing') },
                        ].map(type => (
                            <Fragment key={type.id}>
                                <StyledRadioGroup
                                    value={field.value}
                                    onChange={e => {
                                        setValue('autoClose', e.target.value, {
                                            shouldDirty: true,
                                            shouldValidate: true,
                                        });
                                        if (e.target.value === AutoCloseEnum.Close) {
                                            clearErrors('unassignTimeout');
                                        }
                                        if (e.target.value === AutoCloseEnum.Unassign) {
                                            clearErrors('closeTimeout');
                                        }
                                        setValue('daysUnassign', '00');
                                        setValue('hoursUnassign', '00');
                                        setValue('minutesUnassign', '00');
                                        setValue('daysClose', '00');
                                        setValue('hoursClose', '00');
                                        setValue('minutesClose', '00');
                                    }}
                                >
                                    <FormControlLabel
                                        value={`${type.id}`}
                                        control={
                                            <Radio
                                                sx={{
                                                    color: 'rgba(0, 0, 0, 0.6)',
                                                    padding: '6px',
                                                    '&.Mui-checked': { color: '#1F4C5C' },
                                                }}
                                                disabled={isView}
                                            />
                                        }
                                        label={
                                            <Typography variant="body2" sx={{ marginLeft: '10px' }}>
                                                {type.name}
                                            </Typography>
                                        }
                                        disabled={isView}
                                    ></FormControlLabel>
                                </StyledRadioGroup>
                                {autoClose === AutoCloseEnum.Close && type.id === AutoCloseEnum.Close && (
                                    <AutoCloseInput isView={isView} fieldName="closeTimeout" base="Close" />
                                )}
                                {autoClose === AutoCloseEnum.Unassign && type.id === AutoCloseEnum.Unassign && (
                                    <AutoCloseInput isView={isView} fieldName="unassignTimeout" base="Unassign" />
                                )}
                            </Fragment>
                        ))}
                    </div>
                )}
            />
        </div>
    );
};

export default AutoClose;
